module.exports = __webpack_public_path__ + "img/value_mock.cb61c612.png";